<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6WEoY7/tc-custom/9781426838095.jpg?1706796379761" alt="This image is the cover for the book Notorious Mr. Hurst, Those Scandalous Ravenhursts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Notorious Mr. Hurst, Those Scandalous Ravenhursts
      </h1>
      <p class="bookDescription body article font2">
        <p>Lady Maude Templeton has turned down many a marriage proposal. Why? She wants to marry for love—and her heart is set on one man alone.<br/><br/>Theater owner Mr. Eden Hurst is sexy, talented, intelligent—and resoundingly <i>in</i>eligible! What's more, he doesn't believe in love.<br/><br/>It seems an impossible task, but Maude sets out to make Eden realize he needs love…and her. Society is about to see she can be just as shocking as her Ravenhurst friends when she puts her mind to it!<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Louise Allen
      </h2>
      
      <p class="authorDescription body article">Louise Allen has been immersing herself in history for as long as she can remember, finding landscapes and places evoke powerful images of the past. Venice, Burgundy &amp; the Greek islands are favourites. Louise lives on the Norfolk coast &amp; spends her spare time gardening, researching family history or travelling. Please visit Louise&#39;s website, www.louiseallenregency.com, her blog https://janeaustenslondon or find her on Twitter @LouiseRegency and on Facebook.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f470170